<template>
  <div class="player-slider">
    <input type="range" v-if="$parent.player[signatureId]"
      :ref="'slider_' + signatureId"
      :min="$parent.player[signatureId].sliderMin"
      :max="$parent.player[signatureId].sliderMax"
      :value="$parent.player[signatureId].slider"
      @input="onInput"
      :style="'--percentage: '+ calcPercentage +'% 100%'"
    >
    <div class="timer" v-if="$parent.player[signatureId]">
      <span class="max">{{ calcCurrentTime }}</span> / <span class="max">{{ calcMaxTime }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerSlider',
  props: ['signatureId'],
  computed:{
      calcCurrentTime() {
        return this.$parent.player[this.signatureId].slider - this.$parent.player[this.signatureId].sliderMin
      },
      calcMaxTime() {
        return this.$parent.player[this.signatureId].sliderMax - this.$parent.player[this.signatureId].sliderMin
      },
      calcPercentage() {
        return (this.$parent.player[this.signatureId].slider - this.$parent.player[this.signatureId].sliderMin) * 100
          / (this.$parent.player[this.signatureId].sliderMax - this.$parent.player[this.signatureId].sliderMin)
      }
  },
  methods: {
    onInput(event) {
      this.$parent.player[this.signatureId].slider = event.target.value;

      this.$parent.player[this.signatureId].path.filter((d) => d.time <= event.target.value)
        .attr("T", 1)
        .attr("stroke-dashoffset", 0);
      this.$parent.player[this.signatureId].path.filter((d) => d.time > event.target.value)
        .attr("T", 0)
        .attr("stroke-dashoffset", function(d, i) {
          return this.getTotalLength();
        })
    }
  }
}
</script>

<style lang="scss">
.player-slider{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -10px;
  margin-top: 10px;
  border-top: 2px solid #e9e9e9;
  position: relative;

  input[type="range"] {
    -webkit-appearance: none;
    height: 30px;
    border-radius: 0;
    background: #e9e9e9;
    width: 100%;
    cursor: pointer;
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 30px;
    width: 7px;
    border-radius: 2px;
    background: rgba(0,0,0,.5);
    cursor: ew-resize;
    transition: background .3s ease-in-out;
  }

  input[type=range]::-webkit-slider-runnable-track  {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background-image: linear-gradient(#dce7f5, #dce7f5);
    background-size: var(--percentage);
    background-repeat: no-repeat;
  }

  .timer {
    position: absolute;
    right: 0.5rem;
    background: rgba(0,0,0,0.1);
    padding: 0.1rem 0.4rem;
    border-radius: 0.15rem;
    user-select: none;

    &::selection {
    }
  }
}
</style>
